import * as React from 'react';

import {colors} from '../../colors/colors';
import {HourglassRegularIcon} from '../../icon/svg/hourglass-regular-icon';
import {FormattedTimestamp} from '../../timestamp/formatted-timestamp';
import {Body} from '../../typography/body';

type Props = {
    delayedAt: number;
    delayedBy: string | null | undefined;
    delayFor: string;
    delayReason: string | null | undefined;
};

export function TaskDelayStatus(props: Props) {
    return (
        <div className='flex gap-4'>
            {/* @ts-expect-error */}
            <HourglassRegularIcon size={18} color={colors.grey} />
            <Body color='medium' size='small'>
                Delayed by {props.delayedBy || 'Unknown'} on{' '}
                <FormattedTimestamp
                    format={FormattedTimestamp.formats.monthDayYear}
                    datetime={props.delayedAt}
                    isInline={true}
                />{' '}
                for {props.delayFor}
                {props.delayReason && `: ${props.delayReason}`}
            </Body>
        </div>
    );
}
